import { FunctionComponent } from 'react';
import { Drawer } from 'components/UI/V3/Drawer/Drawer';
import AiAgentFrame from './AiAgentFrame';
import styles from './AiAgentPanel.module.scss';

interface Props {
    onClose: () => void;
}

const AiAgentPanel: FunctionComponent<Props> = ({ onClose }) => {
    return (
        <Drawer
            wrapperClassName={styles.wrapper}
            onClose={onClose}
        >
            <AiAgentFrame />
        </Drawer>
    );
};

export default AiAgentPanel;
